<template>
    <v-form :disabled="disabled">
      <v-container fluid>
        <v-row v-for="planInsuranceCarrier in internalPlanInsuranceCarriers" :key="planInsuranceCarrier.Identifier">
          <v-col cols="4">
            <span>
              {{ `${trans(planInsuranceCarrier.InsuranceCarrier, "Name")} (${planInsuranceCarrier.Policy.Number})`}}
            </span>
          </v-col>
          <v-col cols="4">
            <v-checkbox
              v-model="planInsuranceCarrier.TotalWithTaxes"
              :label="$t('components.plancreationwizard.total_with_taxes')"
            />
          </v-col>
          <v-col cols="4">
            <v-checkbox
              v-model="planInsuranceCarrier.TotalWithoutTaxes"
              :label="$t('components.plancreationwizard.total_without_taxes')"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
</template>
<script>
import { translate2 } from "@/trans2";
export default {
  props: [
    "planInsuranceCarriers",
    "disabled"
  ],
  data() {
    return {
      internalPlanInsuranceCarriers: []
    };
  },
  watch: {
    planInsuranceCarriers: {
      handler(v) {
        if (v!== null && v !==undefined) {
          this.internalPlanInsuranceCarriers = v;//JSON.parse(JSON.stringify(v));
        }
      }
    },
    internalPlanInsuranceCarriers: {
      handler(v) {
        // console.log("internal ic ", v);
        this.$emit("plan-insurance-carriers", v);
      },
    },
  },
  mounted() {
    if (this.planInsuranceCarriers!== null && this.planInsuranceCarriers!== undefined) {
          this.internalPlanInsuranceCarriers = JSON.parse(JSON.stringify(this.planInsuranceCarriers));
        }
  },
  methods: {
    trans(item, str) {
      return translate2(item, str);
    },
  },
};
</script>
